var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuinsWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5508 15.593H19.7696C20.4488 15.593 21 16.2722 21 16.8235V17.5266C21 18.2058 20.4488 18.757 19.7696 18.757H15.5508C14.8716 18.757 14.3203 18.0778 14.3203 17.5266V16.8235C14.3203 16.1443 14.8716 15.593 15.5508 15.593Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23045 15.6016H8.44925C9.12846 15.6016 9.6797 16.2808 9.6797 16.832V17.5351C9.6797 18.2143 9.12846 18.7656 8.44925 18.7656H4.23045C3.55124 18.7656 3 18.0864 3 17.5351V16.832C3 16.1528 3.55124 15.6016 4.23045 15.6016Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47084 8.21434L18.3632 8.80004C18.3913 8.80004 18.4195 8.80215 18.4483 8.80215C19.4495 8.80145 20.2609 7.98935 20.2616 6.98813V5.81533C20.2616 5.31893 20.0591 4.84503 19.7005 4.5026C19.3419 4.15949 18.8589 3.97877 18.3632 4.00199L5.4708 4.58769C4.5005 4.63058 3.73621 5.43003 3.73621 6.40099C3.73621 7.37196 4.50054 8.17149 5.47084 8.21434Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3161 9.85405L15.5634 9.73031L15.2413 14.5622C15.3433 14.5474 15.4473 14.5404 15.5507 14.5404H19.7695C19.8729 14.5404 19.9769 14.5474 20.0789 14.5622L19.7449 9.54761C19.3434 9.75151 18.8998 9.85769 18.4491 9.85699C18.4055 9.85699 18.3604 9.85546 18.3161 9.85405Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29373 8.9807L3.92108 14.5677C4.02303 14.5536 4.12709 14.5466 4.23046 14.5466H8.44926C8.55262 14.5466 8.65668 14.5536 8.75865 14.5677L8.41411 9.40388L5.42308 9.26747C5.03074 9.24989 4.64613 9.15216 4.29388 8.98059L4.29373 8.9807Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuinsWhite);
export default __webpack_public_path__ + "static/media/ruins-white.0200a98b86000475effe5e9bc09aefc2.svg";
export { ForwardRef as ReactComponent };